import AsyncConfirm from './AsyncConfirm'

export default AsyncConfirm
